import { MARKETING_TAGS } from '../../../../constants/marketingTags'
import ListingBadge, { BADGE_ORDER_PRIORITY } from './base'
import { hasMarketingTag, isForeclosure } from './utils'

export default class PriceDroppedBadge extends ListingBadge {
  static titleV2 = 'Price Drop'
  static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.SECOND
  static shouldBeIncludedV2 = listing =>
    hasMarketingTag(listing, MARKETING_TAGS.PRCD) && !isForeclosure(listing)
}
